import { render, staticRenderFns } from "./SiteDetails.vue?vue&type=template&id=27dd10a3&scoped=true"
import script from "./SiteDetails.vue?vue&type=script&lang=js"
export * from "./SiteDetails.vue?vue&type=script&lang=js"
import style0 from "./SiteDetails.vue?vue&type=style&index=0&id=27dd10a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd10a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
